import React from "react";
import { Typography } from "../Typography";

const Tabs = ({ tabs = [], activeTab, onTabChange, className = "", variant = "pill" }) => {
  const isSegment = variant === "segment";

  const containerClass = isSegment
    ? "border border-slate-200 rounded-xl p-1.5 flex items-center gap-1 bg-white overflow-x-auto whitespace-nowrap"
    : "bg-slate-100 rounded-lg p-1 flex items-center gap-1 overflow-x-auto whitespace-nowrap";

  return (
    <div className={`${containerClass} ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;

        const buttonClass = isSegment
          ? `px-4 py-2 rounded-lg transition-all duration-200 ease-in-out shrink-0 ${
              isActive
                ? "bg-white border border-slate-200 shadow-sm text-slate-900"
                : "bg-transparent text-slate-500 hover:text-slate-900"
            }`
          : `px-4 py-2.5 rounded-t-lg transition-all duration-200 ease-in-out shrink-0 ${
              isActive
                ? "bg-white text-slate-900 font-medium shadow-sm"
                : "bg-transparent text-slate-600 hover:text-slate-900"
            }`;

        return (
          <button key={tab.id} onClick={() => onTabChange(tab.id)} className={buttonClass}>
            <Typography
              as="span"
              className={`text-sm ${
                isActive ? "font-medium text-slate-900" : "font-normal text-slate-500"
              }`}
            >
              {tab.label}
            </Typography>
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
